export default "__VITE_ASSET__e9c6ece7__"